import { isDefined } from '@sgme/fp';
import { FormattedMessage, FormattedNumber } from 'react-intl';

import { useOptionSelector } from '@/App/tiles/Option/OptionContext.ts';
import { getQuote, selectOptionQuoteLegs } from '@/store/option/selectors/optionSelectors.ts';
import type { LegId } from '@/store/option/state.ts';

export function AtmVolatilityOrMessage() {
  const { expiredPrice, salesTiering, midVolatility } = useOptionSelector((option) => {
    const tileId = option.properties.tileId;
    const legId: LegId = `${tileId}/0`;
    const legData = selectOptionQuoteLegs(option, legId);
    const quote = getQuote(option);

    return {
      expiredPrice: option.properties.rfs.status === 'EXPIRED',
      salesTiering: quote?.tiering === 'STREAMDEFAULT',
      midVolatility: legData?.midVolatility,
    };
  });

  if (expiredPrice) {
    return (
      <span className="badge rounded-pill badge-secondary fs-12 my-1 py-0" data-e2e="expired-price">
        <FormattedMessage id="streaming.expired.price" />
      </span>
    );
  }

  if (salesTiering) {
    return (
      <span className="badge rounded-pill badge-warning fs-12 my-1 py-0" data-e2e="sales-tier">
        <FormattedMessage id="tile.SaleTier" />
      </span>
    );
  }

  return (
    <div className="px-1 text-black bg-light monospace-numbers p-1" data-e2e="atm-volatility">
      A:{' '}
      {isDefined(midVolatility?.atmVolatilityMid) ? (
        <FormattedNumber value={midVolatility.atmVolatilityMid} minimumFractionDigits={3} />
      ) : (
        '-'
      )}
    </div>
  );
}

